import React, { useEffect, useReducer, ReactNode } from 'react'
import { GetLocalStorage, SetLocalStorage, isResponseCodeSuccess } from '../../tools/util'
import { history } from '../../redux/store'
import copy from 'copy-to-clipboard'
import { message } from 'antd'
import { ResizeCallbackData } from 'react-resizable'
import { ColumnType } from 'antd/lib/table'
import {
  GetRowKey,
  RowSelectionType,
  SelectionSelectFn,
} from 'antd/lib/table/interface'
import { QUERY_FILTER, SAVE_FILTER } from '../../api/screeningSchemeApi'
import { getFilterTypeValue } from './filterTypeEnum'

const ACTION_TYPE = {
  SET_CHECKDATA: 'TABLE/SET_CHECKDATA', // 填充checkbox数据
  SWITCH_VISIBLE: 'TABLE/SWITCH_VISIBLE', // 控制筛选列box显示隐藏
  SET_FOCUSDATA: 'TABLE/SET_FOCUSDATA', // 保存focus数据
  SET_FILTER_COL: 'TABLE/SET_FILTER_COL', // 设置显示的列数据
  SET_CHECKLENGTH: 'TABLE/SET_CHECKLENGTH', // 勾选的数据长度
  SET_Highlight: 'TABLE/SET_Highlight', // 设置高亮
  SET_COL: 'TABLE/SET_COL', // 设置列
  SET_CHECKED_ROWS: 'TABLE/SET_CHECKED_ROWS', // 勾选项所在行的数据
}
interface State {
  filterbtn: boolean
  checkBoxData: checkbox[]
  dataSourceList: any[]
  checkLength: string[]
  focusData: {
    text: string
    x?: number
    y?: number
  }
  highlight: {
    x?: number
    y?: number
  }
  filterCol: string[] //
  Column: ColumnType<any>[]
  checkedRows: any[]
}
const defaultState: State = {
  filterbtn: false,
  checkBoxData: [],
  dataSourceList: [],
  checkLength: [],
  focusData: {
    text: '',
  },
  highlight: {},
  filterCol: [],
  Column: [],
  checkedRows: [],
}

const reducer = (
  state = defaultState,
  action: { type: string; value?: any },
) => {
  const arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SWITCH_VISIBLE:
      arr.filterbtn = action.value
      return arr
    case ACTION_TYPE.SET_CHECKDATA:
      arr.checkBoxData = action.value
      return arr
    case ACTION_TYPE.SET_FOCUSDATA:
      arr.focusData = action.value
      return arr
    case ACTION_TYPE.SET_CHECKLENGTH:
      arr.checkLength = action.value
      return arr
    case ACTION_TYPE.SET_CHECKED_ROWS:
      arr.checkedRows = action.value
      return arr
    case ACTION_TYPE.SET_FILTER_COL:
      arr.filterCol = action.value
      return arr
    case ACTION_TYPE.SET_COL:
      arr.Column = action.value
      return arr
    case ACTION_TYPE.SET_Highlight:
      arr.highlight = action.value
      return arr

    default:
      return arr
  }
}
const setCheckLengthAction = (param: (string | number)[]) => ({
  type: ACTION_TYPE.SET_CHECKLENGTH,
  value: param,
})
const setCheckedRowsAction = (param: any[]) => ({
  type: ACTION_TYPE.SET_CHECKED_ROWS,
  value: param,
})
// 设置需要显示的列
const setFilterColDataAction = (param: string[]) => ({
  type: ACTION_TYPE.SET_FILTER_COL,
  value: param,
})

const setDataFoucsAction = (param: {
  text: string
  x?: number
  y?: number
}) => ({
  type: ACTION_TYPE.SET_FOCUSDATA,
  value: param,
})

const setHighlightAction = (param: { x?: number; y?: number }) => ({
  type: ACTION_TYPE.SET_Highlight,
  value: param,
})
const setCheckboxAction = (param: checkbox[]) => ({
  type: ACTION_TYPE.SET_CHECKDATA,
  value: param,
})

const setFilterbtnAction = (param: boolean) => ({
  type: ACTION_TYPE.SWITCH_VISIBLE,
  value: param,
})

const setColAction = (param: ColumnType<any>[]) => ({
  type: ACTION_TYPE.SET_COL,
  value: param,
})

export interface Collist {
  key: string
  title: string
  titleRender?: ReactNode
  width?: number
  // 当前行的值，当前行数据，行索引
  render?: (text: any, record: any, index: number) => any
  [x: string]: any
}

interface mod {
  key: string
  list: string[]
}

interface CheckItem {
  key: string
  check: boolean
}

interface contextMenuItem {
  title: string
  onClick: () => void
  disabled?: boolean
}
export interface Props {
  ScreenColKey?: ScreenColKey // 可以进行筛选的列表模块
  ScreenColOnlyKey?: string | string[] // 筛选模块必选条件
  ScreenColHiddenKey?: string[] // 筛选模块默认不展示的列
  dataSource: any[] // 表格数据源
  listColumn: Collist[] // 表格列
  getRowStyle?: (e: any) => React.CSSProperties | undefined // 改变当前行css
  headerTool?: ReactNode // 头部工具box
  title?: string // 标题
  loading?: boolean // loading
  Y?: number // y轴 固定表头自动固定
  X?: number // x轴 固定表头自动固定
  scrollCustom?: {
    x?: string | number | true | undefined
    y?: string | number | undefined
  } & {
    scrollToFirstRowOnChange?: boolean | undefined
  } // 滚动
  scrollStyle?: React.CSSProperties // 自定义的scrollStyle
  onChangeCheck?: (selectedRowKeys: any, selectedRows: any[]) => void // 选中变化回调checkbox
  showSort?: boolean // 显示 序号
  pagination?: {
    total: number
    current: number
    pagesize: number
    onChange: (page: number, pageSize?: number) => void
  } // 分页
  onShowContextMenu?: (e: any) => contextMenuItem[]
  selectRowType?: RowSelectionType
  defaultlist?: string[]
  paginationBtn?: {
    name: string
    event: (selectedRowKeys: React.Key[], selectedRows: any[]) => void
  }[]
  selfAdaptScroll?: boolean // 自适应滚动范围
  showSize?: boolean
  rowKey?: string | GetRowKey<any>
  onSelectRow?: SelectionSelectFn<any> // 选中某行的回调
  onSelectAll?: (
    selected: boolean,
    selectedRows: any[],
    changeRows: any[],
  ) => void // 全选的回调
  filterType?: string // 列设置模式（远程API）
  positionFixed?: string // 固定位置不可拖拽的列key
  changeFilterCol?: (val: any) => void // 列变化回调
  filterSlotRef?: React.RefObject<HTMLElement | null> // 外部插槽ref，将列设置按钮 portal 到此元素
  [name: string]: any
}

const useHook = (props: Props) => {
  const {
    dataSource,
    listColumn,
    onChangeCheck,
    ScreenColKey,
    ScreenColOnlyKey,
    ScreenColHiddenKey,
    defaultlist,
    filterType,
    positionFixed,
    changeFilterCol,
  } = props

  const [state, dispatch] = useReducer(reducer, defaultState)
  const { checkBoxData, focusData } = state
  useEffect(() => {
    // 切换显示列
    getScreenCol()
    if (!filterType) {
      dispatch(setColAction(listColumn))
    }
    // eslint-disable-next-line
  }, [listColumn, filterType])

  useEffect(() => {
    if (defaultlist) {
      const action = setCheckLengthAction(defaultlist)
      dispatch(action)
    } else {
      const action = setCheckLengthAction([])
      dispatch(action)
    }
    if (history.location.pathname === '/mdm/category') {
      getScreenCol()
    }
    // eslint-disable-next-line
  }, [dataSource])

  // 初始化列数据
  const initializeColumnData = () => {
    return listColumn.map((item) => ({
      key: item.key,
      name: item.title,
      check: true,
      disabled: false,
    }))
  }

  // 获取远程过滤配置
  const getRemoteFilterConfig = async (): Promise<CheckItem[]> => {
    const cacheKey = `${filterType}_filter`
    const sessionData = sessionStorage.getItem(cacheKey)

    if (sessionData) {
      return JSON.parse(sessionData)
    }

    try {
      const res = await QUERY_FILTER(
        getFilterTypeValue(filterType || ''),
      )

      if (isResponseCodeSuccess(res.code) && res.data) {
        const data = JSON.parse(res.data)
        sessionStorage.setItem(cacheKey, res.data)
        return data
      }
    } catch (error) {
      console.error('获取远程过滤配置失败:', error)
    }

    // 失败时使用默认配置
    const defaultConfig = listColumn.map((item) => ({
      key: item.key,
      check: true,
    }))
    sessionStorage.setItem(cacheKey, JSON.stringify(defaultConfig))
    return defaultConfig
  }

  // 处理远程过滤数据
  const processRemoteFilterData = (
    checkData: checkbox[],
    filterData: CheckItem[],
  ) => {
    if (!filterData?.length) return checkData

    const onlyKeys = Array.isArray(ScreenColOnlyKey)
      ? ScreenColOnlyKey
      : ScreenColOnlyKey
        ? [ScreenColOnlyKey]
        : []

    return checkData
      .sort((a, b) => {
        if (a.key === positionFixed) return -1
        if (b.key === positionFixed) return 1
        return (
          filterData.findIndex((item) => item.key === a.key) -
          filterData.findIndex((item) => item.key === b.key)
        )
      })
      .map((item) => {
        const targetItem = filterData.find((i) => i.key === item.key)
        const shouldCheck =
          targetItem === undefined || // 新字段默认显示
          targetItem.check === true ||
          onlyKeys.includes(item.key)

        return {
          ...item,
          check: shouldCheck,
        }
      })
  }

  // 生成列配置（filterType模式）
  const generateColumnConfig = (checkData: checkbox[]) => {
    return checkData.map((item) => {
      const col: any = listColumn.find((i) => i.key === item.key) || {}
      return { ...item, ...col }
    })
  }

  // 获取 筛选col模块数据
  async function getScreenCol() {
    if (filterType) {
      // 远程配置模式
      let checkData: any[] = initializeColumnData()
      const filterData = await getRemoteFilterConfig()
      checkData = processRemoteFilterData(checkData, filterData)
      const filtercol = checkData.filter((item) => item.check).map((item) => item.key)
      dispatch(setFilterColDataAction(filtercol))
      dispatch(setCheckboxAction(checkData))
      changeFilterCol?.(filtercol)
      dispatch(setColAction(generateColumnConfig(checkData)))
      return
    }

    // 本地存储模式（原有逻辑）
    let checkData = initializeColumnData()
    let filtercol = listColumn.map((item) => item.key)
    const data: mod[] = GetLocalStorage('MDM_FILTERCOL')
    if (data && data.length > 0) {
      if (ScreenColKey) {
        const mod = data.filter((item) => item.key === ScreenColKey)
        if (mod.length === 1) {
          checkData = checkData.map((item) => {
            if (mod[0].list.indexOf(item.key) === -1) {
              return {
                key: item.key,
                name: item.name,
                disabled: item.disabled,
                check: false,
              }
            }
            return item
          })
          if (mod[0].list.length > 0) {
            filtercol = mod[0].list
          }
        }
      }
    } else if (ScreenColHiddenKey) {
      checkData = checkData.map((item) => {
        const targetIndex = ScreenColHiddenKey.findIndex((i) => i === item.key)
        if (targetIndex !== -1) {
          return {
            key: item.key,
            name: item.name,
            disabled: item.disabled,
            check: false,
          }
        }
        return item
      })
      filtercol = checkData.filter((item) => item.check).map((item) => item.key)
    }
    // 需要显示的列
    dispatch(setFilterColDataAction(filtercol))
    // 可筛选的列
    dispatch(setCheckboxAction(checkData))
  }

  // 显示隐藏 切换
  function onHandleChange(info: checkbox, index: number) {
    // 复选框 check、uncheck
    const checkData = [...checkBoxData]
    checkData[index].check = !checkData[index].check
    dispatch(setCheckboxAction(checkData))
    onClickSave(undefined)
  }

  // FilterList 的 checkbox 变化回调
  function onHandleChange2(selectedRowKeys: React.Key[]) {
    const checkData = checkBoxData.map((item) => ({
      ...item,
      check: selectedRowKeys.includes(item.key),
    }))
    dispatch(setCheckboxAction(checkData))
  }

  // 选中行改变
  const onSelectionChanged = (
    selectedRowKeys: (string | number)[],
    selectedRows: any[],
  ) => {
    if (onChangeCheck) {
      onChangeCheck(selectedRowKeys, selectedRows)
      const action = setCheckLengthAction(selectedRowKeys)
      dispatch(action)
      dispatch(setCheckedRowsAction(selectedRows))
    }
  }

  // 单击单元格
  const onCellFocused = (e: any, x: number, y: number) => {
    // 单元格选中状态
    const action = setDataFoucsAction({
      text: e,
      x: x,
      y: y,
    })
    dispatch(action)
  }

  // 复制
  function onKeyDown() {
    copy(focusData.text)
    // 单元格背景高亮
    const action = setHighlightAction({
      x: focusData.x,
      y: focusData.y,
    })
    dispatch(action)
  }
  // 切换筛选列显示
  function handleVisibleChange(flag: boolean) {
    if (filterType && flag) {
      getScreenCol()
    }
    if (!filterType && flag) {
      const data: mod[] = GetLocalStorage('MDM_FILTERCOL')
      let list = [...checkBoxData]
      if (data) {
        const mod = data.filter((item) => item.key === ScreenColKey)
        if (mod.length === 1) {
          // 有方案
          // 设置复选框选中
          const newCheckData = checkBoxData.map((item) => {
            if (mod[0].list.indexOf(item.key) !== -1) {
              return {
                ...item,
                ...{
                  check: true,
                },
              }
            }
            return item
          })
          list = newCheckData
        }
      }
      // 默认添加 固定选中项 不可编辑
      if (ScreenColOnlyKey) {
        const onlyKeys = Array.isArray(ScreenColOnlyKey)
          ? ScreenColOnlyKey
          : [ScreenColOnlyKey]
        list = list.map((item) => {
          if (onlyKeys.includes(item.key)) {
            return {
              ...item,
              ...{
                disabled: true,
              },
            }
          }
          return item
        })
      }
      dispatch(setCheckboxAction(list))
    }
    const action = setFilterbtnAction(flag)
    dispatch(action)
  }

  // 保存筛选项
  const onClickSave = async (data?: any) => {
    // filterType 模式：来自 FilterList 的保存
    if (filterType && data) {
      const visiblekey: string[] = []
      for (let index = 0; index < data.length; index++) {
        if (data[index].check) {
          visiblekey.push(data[index].key)
        }
      }
      const res = await SAVE_FILTER({
        content: data,
        type: getFilterTypeValue(filterType),
      })
      if (isResponseCodeSuccess(res.code)) {
        sessionStorage.setItem(filterType + '_filter', JSON.stringify(data))
      }
      dispatch(
        setColAction(
          data.map((item: any) => {
            const col: any = listColumn.find((i) => i.key === item.key) || {}
            return { ...item, ...col }
          }),
        ),
      )
      dispatch(setFilterColDataAction(visiblekey))
      changeFilterCol?.(visiblekey)
      // 关闭筛选窗
      dispatch(setFilterbtnAction(false))
      message.success('保存成功')
      return
    }

    // 原有本地保存逻辑
    const visiblekey: string[] = [] // 需显示的key
    for (let index = 0; index < checkBoxData.length; index++) {
      if (checkBoxData[index].check) {
        visiblekey.push(checkBoxData[index].key)
      }
    }
    // 需要显示的列
    dispatch(setFilterColDataAction(visiblekey))
    // 获取 checkBoxData 中选中的
    const checkCol = checkBoxData.filter((item) => item.check)
    const colname = checkCol.map((item) => item.key)
    let savedata: mod[] = GetLocalStorage('MDM_FILTERCOL')
    if (savedata && colname.length > 0) {
      const mod = savedata.filter((item) => item.key === ScreenColKey)
      // 有方案 保存 无方案直接添加
      savedata =
        mod.length === 1
          ? savedata.map((i) => {
              if (i.key === ScreenColKey) {
                return {
                  key: i.key,
                  list: colname,
                }
              }
              return i
            })
          : [
              ...savedata,
              {
                key: ScreenColKey ? ScreenColKey : '',
                list: colname,
              },
            ]
    } else {
      // 当前模块无保存过的方案
      savedata = [
        {
          key: ScreenColKey ? ScreenColKey : '',
          list: colname,
        },
      ]
    }
    // 更新状态
    SetLocalStorage('MDM_FILTERCOL', savedata)
    // 关闭筛选窗
    // dispatch(setFilterbtnAction(false))
    // message.success(`保存成功`)
  }

  // 关闭筛选列
  function onClickClose() {
    // 关闭筛选窗
    dispatch(setFilterbtnAction(false))
  }

  // 改变宽度
  const handleResize =
    (index: number) =>
    (e: any, { size }: ResizeCallbackData) => {
      const arr = (filterType ? state.Column : listColumn).map((item: any, i: number) => {
        if (index === i) {
          item.width = size.width
        }
        return item
      })
      const action = setColAction(arr)
      dispatch(action)
    }

  return {
    state,
    onHandleChange,
    onHandleChange2,
    onKeyDown,
    handleVisibleChange,
    onSelectionChanged,
    onCellFocused,
    onClickClose,
    onClickSave,
    handleResize,
  }
}

export default useHook

export interface checkbox {
  key: string
  name: string
  check: boolean
  disabled: boolean
}
// 物料列表 批量新增物料
export type ScreenColKey =
  // 物料列表
  | 'GOODSLIST'
  // 批量新增-列表
  | 'BatchAddGOODS'
  // 我发起的物料-列表
  | 'LAUNCHGOODS'
  // 待我审核的物料-列表
  | 'WAITAUDIT'
  // 已审核的物料-列表
  | 'ENDAUDIT'
  // 纠错审核的物料-列表
  | 'ERRORAUDIT'
  // 发起去存-列表
  | 'STARTSTOCKLIST'
  // 去存审核结果-列表
  | 'ENDSTOCKLIST'
  // 暂存物料-列表
  | 'TEMPGOODS'
  // 商图打包新增-列表
  | 'GOODSPICADD'
  // 商图打包修改-列表
  | 'GOODSPICEDIT'
  // 组织管理-列表
  | 'ORGANIZATION'
  // 品牌管理-列表
  | 'BRANDLIST'
  // 品牌管理-审核结果列表
  | 'BRANDENDAUTDITLIST'
  // 品牌管理-待我审核列表
  | 'BRANDWAITAUDIT'
  // 品牌管理-我发起的列表
  | 'BRANDLUNCH'
  // 员工管理-列表
  | 'EMPLIST'
  // 操作记录
  | 'OPERATIONLIST'
  | 'XHQUOTELIST'
import React, { useEffect, useReducer, ReactNode } from 'react'
import { GetLocalStorage, SetLocalStorage, isResponseCodeSuccess } from '../../tools/util'
import { history } from '../../redux/store'
import copy from 'copy-to-clipboard'
import { message } from 'antd'
import { ResizeCallbackData } from 'react-resizable'
import { ColumnType } from 'antd/lib/table'
import {
  GetRowKey,
  RowSelectionType,
  SelectionSelectFn,
} from 'antd/lib/table/interface'
import { QUERY_FILTER, SAVE_FILTER } from '../../api/screeningSchemeApi'
import { getFilterTypeValue } from './filterTypeEnum'

const ACTION_TYPE = {
  SET_CHECKDATA: 'TABLE/SET_CHECKDATA', // 填充checkbox数据
  SWITCH_VISIBLE: 'TABLE/SWITCH_VISIBLE', // 控制筛选列box显示隐藏
  SET_FOCUSDATA: 'TABLE/SET_FOCUSDATA', // 保存focus数据
  SET_FILTER_COL: 'TABLE/SET_FILTER_COL', // 设置显示的列数据
  SET_CHECKLENGTH: 'TABLE/SET_CHECKLENGTH', // 勾选的数据长度
  SET_Highlight: 'TABLE/SET_Highlight', // 设置高亮
  SET_COL: 'TABLE/SET_COL', // 设置列
  SET_CHECKED_ROWS: 'TABLE/SET_CHECKED_ROWS', // 勾选项所在行的数据
}
interface State {
  filterbtn: boolean
  checkBoxData: checkbox[]
  dataSourceList: any[]
  checkLength: string[]
  focusData: {
    text: string
    x?: number
    y?: number
  }
  highlight: {
    x?: number
    y?: number
  }
  filterCol: string[] //
  Column: ColumnType<any>[]
  checkedRows: any[]
}
const defaultState: State = {
  filterbtn: false,
  checkBoxData: [],
  dataSourceList: [],
  checkLength: [],
  focusData: {
    text: '',
  },
  highlight: {},
  filterCol: [],
  Column: [],
  checkedRows: [],
}

const reducer = (
  state = defaultState,
  action: { type: string; value?: any },
) => {
  const arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SWITCH_VISIBLE:
      arr.filterbtn = action.value
      return arr
    case ACTION_TYPE.SET_CHECKDATA:
      arr.checkBoxData = action.value
      return arr
    case ACTION_TYPE.SET_FOCUSDATA:
      arr.focusData = action.value
      return arr
    case ACTION_TYPE.SET_CHECKLENGTH:
      arr.checkLength = action.value
      return arr
    case ACTION_TYPE.SET_CHECKED_ROWS:
      arr.checkedRows = action.value
      return arr
    case ACTION_TYPE.SET_FILTER_COL:
      arr.filterCol = action.value
      return arr
    case ACTION_TYPE.SET_COL:
      arr.Column = action.value
      return arr
    case ACTION_TYPE.SET_Highlight:
      arr.highlight = action.value
      return arr

    default:
      return arr
  }
}
const setCheckLengthAction = (param: (string | number)[]) => ({
  type: ACTION_TYPE.SET_CHECKLENGTH,
  value: param,
})
const setCheckedRowsAction = (param: any[]) => ({
  type: ACTION_TYPE.SET_CHECKED_ROWS,
  value: param,
})
// 设置需要显示的列
const setFilterColDataAction = (param: string[]) => ({
  type: ACTION_TYPE.SET_FILTER_COL,
  value: param,
})

const setDataFoucsAction = (param: {
  text: string
  x?: number
  y?: number
}) => ({
  type: ACTION_TYPE.SET_FOCUSDATA,
  value: param,
})

const setHighlightAction = (param: { x?: number; y?: number }) => ({
  type: ACTION_TYPE.SET_Highlight,
  value: param,
})
const setCheckboxAction = (param: checkbox[]) => ({
  type: ACTION_TYPE.SET_CHECKDATA,
  value: param,
})

const setFilterbtnAction = (param: boolean) => ({
  type: ACTION_TYPE.SWITCH_VISIBLE,
  value: param,
})

const setColAction = (param: ColumnType<any>[]) => ({
  type: ACTION_TYPE.SET_COL,
  value: param,
})

export interface Collist {
  key: string
  title: string
  titleRender?: ReactNode
  width?: number
  // 当前行的值，当前行数据，行索引
  render?: (text: any, record: any, index: number) => any
  [x: string]: any
}

interface mod {
  key: string
  list: string[]
}

interface CheckItem {
  key: string
  check: boolean
}

interface contextMenuItem {
  title: string
  onClick: () => void
  disabled?: boolean
}
export interface Props {
  ScreenColKey?: ScreenColKey // 可以进行筛选的列表模块
  ScreenColOnlyKey?: string | string[] // 筛选模块必选条件
  ScreenColHiddenKey?: string[] // 筛选模块默认不展示的列
  dataSource: any[] // 表格数据源
  listColumn: Collist[] // 表格列
  getRowStyle?: (e: any) => React.CSSProperties | undefined // 改变当前行css
  headerTool?: ReactNode // 头部工具box
  title?: string // 标题
  loading?: boolean // loading
  Y?: number // y轴 固定表头自动固定
  X?: number // x轴 固定表头自动固定
  scrollCustom?: {
    x?: string | number | true | undefined
    y?: string | number | undefined
  } & {
    scrollToFirstRowOnChange?: boolean | undefined
  } // 滚动
  scrollStyle?: React.CSSProperties // 自定义的scrollStyle
  onChangeCheck?: (selectedRowKeys: any, selectedRows: any[]) => void // 选中变化回调checkbox
  showSort?: boolean // 显示 序号
  pagination?: {
    total: number
    current: number
    pagesize: number
    onChange: (page: number, pageSize?: number) => void
  } // 分页
  onShowContextMenu?: (e: any) => contextMenuItem[]
  selectRowType?: RowSelectionType
  defaultlist?: string[]
  paginationBtn?: {
    name: string
    event: (selectedRowKeys: React.Key[], selectedRows: any[]) => void
  }[]
  selfAdaptScroll?: boolean // 自适应滚动范围
  showSize?: boolean
  rowKey?: string | GetRowKey<any>
  onSelectRow?: SelectionSelectFn<any> // 选中某行的回调
  onSelectAll?: (
    selected: boolean,
    selectedRows: any[],
    changeRows: any[],
  ) => void // 全选的回调
  filterType?: string // 列设置模式（远程API）
  positionFixed?: string // 固定位置不可拖拽的列key
  changeFilterCol?: (val: any) => void // 列变化回调
  filterSlotRef?: React.RefObject<HTMLElement | null> // 外部插槽ref，将列设置按钮 portal 到此元素
  [name: string]: any
}

const useHook = (props: Props) => {
  const {
    dataSource,
    listColumn,
    onChangeCheck,
    ScreenColKey,
    ScreenColOnlyKey,
    ScreenColHiddenKey,
    defaultlist,
    filterType,
    positionFixed,
    changeFilterCol,
  } = props

  const [state, dispatch] = useReducer(reducer, defaultState)
  const { checkBoxData, focusData } = state
  useEffect(() => {
    // 切换显示列
    getScreenCol()
    if (!filterType) {
      dispatch(setColAction(listColumn))
    }
    // eslint-disable-next-line
  }, [listColumn, filterType])

  useEffect(() => {
    if (defaultlist) {
      const action = setCheckLengthAction(defaultlist)
      dispatch(action)
    } else {
      const action = setCheckLengthAction([])
      dispatch(action)
    }
    if (history.location.pathname === '/mdm/category') {
      getScreenCol()
    }
    // eslint-disable-next-line
  }, [dataSource])

  // 初始化列数据
  const initializeColumnData = () => {
    return listColumn.map((item) => ({
      key: item.key,
      name: item.title,
      check: true,
      disabled: false,
    }))
  }

  // 获取远程过滤配置
  const getRemoteFilterConfig = async (): Promise<CheckItem[]> => {
    const cacheKey = `${filterType}_filter`
    const sessionData = sessionStorage.getItem(cacheKey)

    if (sessionData) {
      return JSON.parse(sessionData)
    }

    try {
      const res = await QUERY_FILTER(
        getFilterTypeValue(filterType || ''),
      )

      if (isResponseCodeSuccess(res.code) && res.data) {
        const data = JSON.parse(res.data)
        sessionStorage.setItem(cacheKey, res.data)
        return data
      }
    } catch (error) {
      console.error('获取远程过滤配置失败:', error)
    }

    // 失败时使用默认配置
    const defaultConfig = listColumn.map((item) => ({
      key: item.key,
      check: true,
    }))
    sessionStorage.setItem(cacheKey, JSON.stringify(defaultConfig))
    return defaultConfig
  }

  // 处理远程过滤数据
  const processRemoteFilterData = (
    checkData: checkbox[],
    filterData: CheckItem[],
  ) => {
    if (!filterData?.length) return checkData

    const onlyKeys = Array.isArray(ScreenColOnlyKey)
      ? ScreenColOnlyKey
      : ScreenColOnlyKey
        ? [ScreenColOnlyKey]
        : []

    return checkData
      .sort((a, b) => {
        if (a.key === positionFixed) return -1
        if (b.key === positionFixed) return 1
        return (
          filterData.findIndex((item) => item.key === a.key) -
          filterData.findIndex((item) => item.key === b.key)
        )
      })
      .map((item) => {
        const targetItem = filterData.find((i) => i.key === item.key)
        const shouldCheck =
          targetItem === undefined || // 新字段默认显示
          targetItem.check === true ||
          onlyKeys.includes(item.key)

        return {
          ...item,
          check: shouldCheck,
        }
      })
  }

  // 生成列配置（filterType模式）
  const generateColumnConfig = (checkData: checkbox[]) => {
    return checkData.map((item) => {
      const col: any = listColumn.find((i) => i.key === item.key) || {}
      return { ...item, ...col }
    })
  }

  // 获取 筛选col模块数据
  async function getScreenCol() {
    if (filterType) {
      // 远程配置模式
      let checkData: any[] = initializeColumnData()
      const filterData = await getRemoteFilterConfig()
      checkData = processRemoteFilterData(checkData, filterData)
      const filtercol = checkData.filter((item) => item.check).map((item) => item.key)
      dispatch(setFilterColDataAction(filtercol))
      dispatch(setCheckboxAction(checkData))
      changeFilterCol?.(filtercol)
      dispatch(setColAction(generateColumnConfig(checkData)))
      return
    }

    // 本地存储模式（原有逻辑）
    let checkData = initializeColumnData()
    let filtercol = listColumn.map((item) => item.key)
    const data: mod[] = GetLocalStorage('MDM_FILTERCOL')
    if (data && data.length > 0) {
      if (ScreenColKey) {
        const mod = data.filter((item) => item.key === ScreenColKey)
        if (mod.length === 1) {
          checkData = checkData.map((item) => {
            if (mod[0].list.indexOf(item.key) === -1) {
              return {
                key: item.key,
                name: item.name,
                disabled: item.disabled,
                check: false,
              }
            }
            return item
          })
          if (mod[0].list.length > 0) {
            filtercol = mod[0].list
          }
        }
      }
    } else if (ScreenColHiddenKey) {
      checkData = checkData.map((item) => {
        const targetIndex = ScreenColHiddenKey.findIndex((i) => i === item.key)
        if (targetIndex !== -1) {
          return {
            key: item.key,
            name: item.name,
            disabled: item.disabled,
            check: false,
          }
        }
        return item
      })
      filtercol = checkData.filter((item) => item.check).map((item) => item.key)
    }
    // 需要显示的列
    dispatch(setFilterColDataAction(filtercol))
    // 可筛选的列
    dispatch(setCheckboxAction(checkData))
  }

  // 显示隐藏 切换
  function onHandleChange(info: checkbox, index: number) {
    // 复选框 check、uncheck
    const checkData = [...checkBoxData]
    checkData[index].check = !checkData[index].check
    dispatch(setCheckboxAction(checkData))
    onClickSave(undefined)
  }

  // FilterList 的 checkbox 变化回调
  function onHandleChange2(selectedRowKeys: React.Key[]) {
    const checkData = checkBoxData.map((item) => ({
      ...item,
      check: selectedRowKeys.includes(item.key),
    }))
    dispatch(setCheckboxAction(checkData))
  }

  // 选中行改变
  const onSelectionChanged = (
    selectedRowKeys: (string | number)[],
    selectedRows: any[],
  ) => {
    if (onChangeCheck) {
      onChangeCheck(selectedRowKeys, selectedRows)
      const action = setCheckLengthAction(selectedRowKeys)
      dispatch(action)
      dispatch(setCheckedRowsAction(selectedRows))
    }
  }

  // 单击单元格
  const onCellFocused = (e: any, x: number, y: number) => {
    // 单元格选中状态
    const action = setDataFoucsAction({
      text: e,
      x: x,
      y: y,
    })
    dispatch(action)
  }

  // 复制
  function onKeyDown() {
    copy(focusData.text)
    // 单元格背景高亮
    const action = setHighlightAction({
      x: focusData.x,
      y: focusData.y,
    })
    dispatch(action)
  }
  // 切换筛选列显示
  function handleVisibleChange(flag: boolean) {
    if (filterType && flag) {
      getScreenCol()
    }
    if (!filterType && flag) {
      const data: mod[] = GetLocalStorage('MDM_FILTERCOL')
      let list = [...checkBoxData]
      if (data) {
        const mod = data.filter((item) => item.key === ScreenColKey)
        if (mod.length === 1) {
          // 有方案
          // 设置复选框选中
          const newCheckData = checkBoxData.map((item) => {
            if (mod[0].list.indexOf(item.key) !== -1) {
              return {
                ...item,
                ...{
                  check: true,
                },
              }
            }
            return item
          })
          list = newCheckData
        }
      }
      // 默认添加 固定选中项 不可编辑
      if (ScreenColOnlyKey) {
        const onlyKeys = Array.isArray(ScreenColOnlyKey)
          ? ScreenColOnlyKey
          : [ScreenColOnlyKey]
        list = list.map((item) => {
          if (onlyKeys.includes(item.key)) {
            return {
              ...item,
              ...{
                disabled: true,
              },
            }
          }
          return item
        })
      }
      dispatch(setCheckboxAction(list))
    }
    const action = setFilterbtnAction(flag)
    dispatch(action)
  }

  // 保存筛选项
  const onClickSave = async (data?: any) => {
    // filterType 模式：来自 FilterList 的保存
    if (filterType && data) {
      const visiblekey: string[] = []
      for (let index = 0; index < data.length; index++) {
        if (data[index].check) {
          visiblekey.push(data[index].key)
        }
      }
      const res = await SAVE_FILTER({
        content: data,
        type: getFilterTypeValue(filterType),
      })
      if (isResponseCodeSuccess(res.code)) {
        sessionStorage.setItem(filterType + '_filter', JSON.stringify(data))
      }
      dispatch(
        setColAction(
          data.map((item: any) => {
            const col: any = listColumn.find((i) => i.key === item.key) || {}
            return { ...item, ...col }
          }),
        ),
      )
      dispatch(setFilterColDataAction(visiblekey))
      changeFilterCol?.(visiblekey)
      // 关闭筛选窗
      dispatch(setFilterbtnAction(false))
      message.success('保存成功')
      return
    }

    // 原有本地保存逻辑
    const visiblekey: string[] = [] // 需显示的key
    for (let index = 0; index < checkBoxData.length; index++) {
      if (checkBoxData[index].check) {
        visiblekey.push(checkBoxData[index].key)
      }
    }
    // 需要显示的列
    dispatch(setFilterColDataAction(visiblekey))
    // 获取 checkBoxData 中选中的
    const checkCol = checkBoxData.filter((item) => item.check)
    const colname = checkCol.map((item) => item.key)
    let savedata: mod[] = GetLocalStorage('MDM_FILTERCOL')
    if (savedata && colname.length > 0) {
      const mod = savedata.filter((item) => item.key === ScreenColKey)
      // 有方案 保存 无方案直接添加
      savedata =
        mod.length === 1
          ? savedata.map((i) => {
              if (i.key === ScreenColKey) {
                return {
                  key: i.key,
                  list: colname,
                }
              }
              return i
            })
          : [
              ...savedata,
              {
                key: ScreenColKey ? ScreenColKey : '',
                list: colname,
              },
            ]
    } else {
      // 当前模块无保存过的方案
      savedata = [
        {
          key: ScreenColKey ? ScreenColKey : '',
          list: colname,
        },
      ]
    }
    // 更新状态
    SetLocalStorage('MDM_FILTERCOL', savedata)
    // 关闭筛选窗
    // dispatch(setFilterbtnAction(false))
    // message.success(`保存成功`)
  }

  // 关闭筛选列
  function onClickClose() {
    // 关闭筛选窗
    dispatch(setFilterbtnAction(false))
  }

  // 改变宽度
  const handleResize =
    (index: number) =>
    (e: any, { size }: ResizeCallbackData) => {
      const arr = (filterType ? state.Column : listColumn).map((item: any, i: number) => {
        if (index === i) {
          item.width = size.width
        }
        return item
      })
      const action = setColAction(arr)
      dispatch(action)
    }

  return {
    state,
    onHandleChange,
    onHandleChange2,
    onKeyDown,
    handleVisibleChange,
    onSelectionChanged,
    onCellFocused,
    onClickClose,
    onClickSave,
    handleResize,
  }
}

export default useHook

export interface checkbox {
  key: string
  name: string
  check: boolean
  disabled: boolean
}
// 物料列表 批量新增物料
export type ScreenColKey =
  // 物料列表
  | 'GOODSLIST'
  // 批量新增-列表
  | 'BatchAddGOODS'
  // 我发起的物料-列表
  | 'LAUNCHGOODS'
  // 待我审核的物料-列表
  | 'WAITAUDIT'
  // 已审核的物料-列表
  | 'ENDAUDIT'
  // 纠错审核的物料-列表
  | 'ERRORAUDIT'
  // 发起去存-列表
  | 'STARTSTOCKLIST'
  // 去存审核结果-列表
  | 'ENDSTOCKLIST'
  // 暂存物料-列表
  | 'TEMPGOODS'
  // 商图打包新增-列表
  | 'GOODSPICADD'
  // 商图打包修改-列表
  | 'GOODSPICEDIT'
  // 组织管理-列表
  | 'ORGANIZATION'
  // 品牌管理-列表
  | 'BRANDLIST'
  // 品牌管理-审核结果列表
  | 'BRANDENDAUTDITLIST'
  // 品牌管理-待我审核列表
  | 'BRANDWAITAUDIT'
  // 品牌管理-我发起的列表
  | 'BRANDLUNCH'
  // 员工管理-列表
  | 'EMPLIST'
  // 操作记录
  | 'OPERATIONLIST'
  | 'XHQUOTELIST'
